<div>
    <div role="alert"
         class="alert alert-info">Orphan Users are those accounts that aren't attached to any people records (mistakenly added or not
        cleaned up properly)</div>

    <button class="btn btn-default"
            [adaptBlockingClick]="doCheck">Check for Orphan Users</button>

    <hr />

    @if (users) {
        <div>
            <table class="table table-bordered table-striped table-hover table-responsive">
                <thead>
                    <tr>
                        <td>UserId</td>
                        <td>Email</td>
                    </tr>
                </thead>
                <tbody>
                    @for (user of users; track user) {
                        <tr>
                            <td>{{ user.Id }}</td>
                            <td>{{ user.Value }}</td>
                        </tr>
                    }
                </tbody>
            </table>
            <hr />
            @if (users.length) {
                <div role="alert"
                     class="alert alert-warning">
                    <h3>*** Note: This operation is not recoverable. ***</h3>
                </div>
            }
            @if (users.length) {
                <button [adaptBlockingClick]="doDelete"
                        adaptButton="delete">Orphan Users</button>
            }
        </div>
    }

    @if (error) {
        <div role="alert"
             class="alert alert-danger">{{ error }}</div>
    }
</div>
